import FormLabel from '@mui/material/FormLabel';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { GroupFieldConfiguration } from '../../../api/ConfigApi';
import { AuthData } from '../../../context/auth';
import { PolicyData, withPolicyContext } from '../../../context/policy';
import { socotraGray2 } from '../../../data/globalStylingVariables';
import {
	FieldGroupCreateRequest,
	FieldGroupsByLocatorMap,
	FieldValues,
	FieldValuesMap,
} from '../../../types/policy';
import FieldEditorFormReviewChanges from '../FieldEditorFormReviewChanges';

interface Props {
	field: GroupFieldConfiguration;
	fieldGroupLocators?: FieldValues;
	fieldGroupsByLocator: FieldGroupsByLocatorMap;
	policyData: PolicyData;
	authData: AuthData;
	addFieldGroups?: FieldGroupCreateRequest[]; // endorsement add new field groups array
	currentFieldValues: FieldValuesMap; // current field values are the pending changes that the user is making
}

const GroupFieldReadOnly = (props: Props) => {
	const {
		field,
		fieldGroupLocators,
		fieldGroupsByLocator,
		addFieldGroups,
		currentFieldValues,
	} = props;

	const getFieldGroupLocators = () => {
		return fieldGroupLocators || [];
	};

	const renderGroup = (
		values: FieldValuesMap = {},
		index: number,
		locator?: string,
	): JSX.Element => {
		// const values = fieldGroupsByLocator[locator] || {};

		return (
			<GroupFieldWrapper key={`${locator}-${index}`}>
				<FieldEditorFormReviewChanges
					fieldConfigurations={field.fields}
					fieldValues={values}
					currentFieldValues={currentFieldValues}
					fieldGroupsByLocator={null}
					groupIndex={locator || index.toString()}
				/>
			</GroupFieldWrapper>
		);
	};

	const renderGroups = () => {
		if (!getFieldGroupLocators.length) {
			return null;
		}

		return (
			<>
				<h5>Updated</h5>
				{getFieldGroupLocators().map((locator: string, index: number) =>
					renderGroup(fieldGroupsByLocator[locator], index, locator),
				)}
			</>
		);
	};

	const renderAddFieldGroups = () => {
		if (!addFieldGroups || !addFieldGroups.length) {
			return null;
		}

		return (
			<>
				<h5>Added</h5>
				{addFieldGroups
					.filter(({ fieldName }) => fieldName === field.name)
					.map((afg, index) => renderGroup(afg.fieldValues, index, null))}
			</>
		);
	};

	return (
		<Fragment>
			<FormLabel>{field.title || ''}</FormLabel>
			{renderGroups()}
			{renderAddFieldGroups()}
		</Fragment>
	);
};

const GroupFieldWrapper = styled.div`
	border: 1px dotted ${socotraGray2};
	padding: 10px;
	width: 100%;
	margin-bottom: 8px;
`;

export default withPolicyContext<Props>(GroupFieldReadOnly);
